import { createQueryKeys } from "../../shared/utils/create-query-keys";

export const caregiverSuppliesShipmentsQueryKeys = createQueryKeys("caregiver_supplies_shipments", {
  search: (params: Record<string, unknown>) => params,
  shipments: null,
});
